<h3 class="card-title">{{ 'agreement.status' | translate }}</h3>

<div class="wrapper">
  <ax-agreement-status-chip [status]="activeStatus"></ax-agreement-status-chip>
  @if (hasAgreementDataToDisplay) {
    <ax-agreement-status-chip
      [status]="isConfirmed ? 'confirmed' : 'not-confirmed'"
    ></ax-agreement-status-chip>

    @if (proposalHasVerification) {
      <ax-agreement-status-chip
        [status]="isVerified ? 'verified' : 'not-verified'"
      ></ax-agreement-status-chip>
    }
  }
</div>
